import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL;

// Dropdown sourced from the Compliance Standards catalogue (/quality/standards).
// single (default): value = code string, onChange(code).
// multi: value = array of codes, onChange(codes[]).
// Legacy free-text values not in the catalogue are preserved as options/chips.
export default function StandardPicker({ value, onChange, multi = false, getToken, accent = '#2dd4bf', placeholder = 'Select standard…' }) {
  const [standards, setStandards] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const res = await window.fetch(`${API_BASE}/quality/standards`, { headers: { Authorization: `Bearer ${token}` } });
        const d = await res.json();
        if (!cancelled && d.ok) setStandards(d.standards || []);
      } catch { /* leave empty — falls back to whatever value is set */ }
    })();
    return () => { cancelled = true; };
  }, [getToken]);

  const inp = {
    background: 'var(--ni-panel)', border: '1px solid var(--ni-border-soft)', color: 'var(--ni-text)',
    borderRadius: 6, padding: '8px 12px', fontSize: 13, width: '100%', boxSizing: 'border-box',
  };
  const label = (s) => `${s.code}${s.title ? ` — ${s.title}` : ''}`;

  if (!multi) {
    const known = standards.some(s => s.code === value);
    return (
      <select value={value || ''} onChange={e => onChange(e.target.value)} style={inp}>
        <option value="">{placeholder}</option>
        {value && !known && <option value={value}>{value} (not in catalogue)</option>}
        {standards.map(s => <option key={s._id} value={s.code}>{label(s)}</option>)}
      </select>
    );
  }

  const arr = Array.isArray(value) ? value : [];
  const add = (code) => { if (code && !arr.includes(code)) onChange([...arr, code]); };
  const remove = (code) => onChange(arr.filter(c => c !== code));

  return (
    <div>
      <select value="" onChange={e => { add(e.target.value); e.target.value = ''; }} style={inp}>
        <option value="">+ Add standard…</option>
        {standards.filter(s => !arr.includes(s.code)).map(s => <option key={s._id} value={s.code}>{label(s)}</option>)}
      </select>
      {arr.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
          {arr.map(code => {
            const s = standards.find(x => x.code === code);
            return (
              <span key={code} title={s ? s.title : 'Not in catalogue'}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 20,
                  fontSize: 12, fontWeight: 700, background: accent + '22', color: accent }}>
                {code}
                <button type="button" onClick={() => remove(code)}
                  style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, fontSize: 13, lineHeight: 1 }}>×</button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}
